import { Seconds } from '@ankr.com/utils/unit';
import BigNumber from 'bignumber.js';

export const ZERO = new BigNumber(0);

export const ZERO_STRING = '0';

export const DEFAULT_TOKEN_DECIMALS = 18;

export enum EMilliSeconds {
  Second = 1000,
  Minute = Second * 60,
  Hour = Minute * 60,
  Day = Hour * 24,
  Week = Day * 7,
  Month = Day * 30,
  Year = Day * 365,
}

export enum ESeconds {
  Minute = 60,
  Hour = Minute * 60,
  Day = Hour * 24,
  Week = Day * 7,
  Month = Day * 30,
  Year = Day * 365,
}

const DIALOG_MARGIN = 32;
const DIALOG_PADDING = 40;
const DIALOG_HEADER = 70;
const DIALOG_OFFSET = DIALOG_MARGIN * 2 + DIALOG_PADDING * 2 + DIALOG_HEADER;

export const dialogAuthoHeightMax = `calc(100vh - ${DIALOG_OFFSET}px)`;

export const TELEGRAM_COLOR = '#509FDA';

export const ANKR_DOCS_LINKS = {
  aapiOverview: 'https://www.ankr.com/docs/advanced-api/overview/',
  aapiReactHooks: 'https://www.ankr.com/docs/advanced-api/react-hooks/',
  aapiSupportedChains:
    'https://www.ankr.com/docs/advanced-api/overview/#chains-supported',
  aapiSupportedMethods:
    'https://www.ankr.com/docs/advanced-api/overview/#aapi-methods-supported',
  chainsList: 'https://www.ankr.com/docs/rpc-service/chains/chains-list/',
  chargingModels:
    'https://www.ankr.com/docs/rpc-service/service-plans/#charging-models',
  dealModel: 'https://www.ankr.com/docs/rpc-service/service-plans/#deal',
  editAccessRoles:
    'https://www.ankr.com/docs/rpc-service/getting-started/team-accounts/#edit-access-roles',
  intro: 'https://www.ankr.com/docs/rpc-service/getting-started/intro/',
  inviteTeammates:
    'https://www.ankr.com/docs/rpc-service/getting-started/team-accounts/#invite-teammates',
  overview: 'https://www.ankr.com/docs/rpc-service/overview/',
  pricing: 'https://www.ankr.com/docs/rpc-service/pricing/',
  projects: 'https://www.ankr.com/docs/rpc-service/getting-started/projects/',
  servicePlans: 'https://www.ankr.com/docs/rpc-service/service-plans/',
  teamAccounts:
    'https://www.ankr.com/docs/rpc-service/getting-started/team-accounts/',
};

export const ANKR_SOCIAL_LINKS = {
  discord: 'https://discord.ankr.com/',
  reddit: 'https://www.reddit.com/r/Ankrofficial/',
  substack: 'https://ankr.substack.com/',
  telegram: 'https://t.me/ankrnetwork',
  twitter: 'https://twitter.com/ankr',
};

export const ANKR_TERMS_OF_SERVICE_LINK = 'https://www.ankr.com/terms/';
export const ANKR_PRIVACY_POLICY_LINK = 'https://www.ankr.com/privacy-policy/';

export const AAPI_PYTHON_SDK = 'https://pypi.org/project/ankr-sdk/';
export const AAPI_JS_SDK = 'https://www.npmjs.com/package/@ankr.com/ankr.js';
export const AAPI_ABOUT_LINK =
  'https://www.ankr.com/remote-procedure-call/advanced-api/';

export const TEAM_INVITE_LINK_SEARCH_KEY = 'teamInviteLink';

export const SALES_TEAM_CONTACT =
  'https://meetings-eu1.hubspot.com/arsalan-evini';

export const SUPPORT_PORTAL_LINK =
  'http://helpdesk.ankr.com/?_gl=1*7x6jyr*_ga*Njk4Njg3NTY1LjE3MTg4NzE5MTc.*_ga_0MDHE2B2H8*MTcyOTI0NzQzNi4xNDAuMS4xNzI5MjQ4MjI3LjcuMC4w';

export const SLACK_CREATE_CHANNEL_DOCS_LINK =
  'https://slack.com/help/articles/201402297-Create-a-channel';
export const BASE_SLACK_LINK = 'https://slack.com';

export const X_POST_LINK = 'https://x.com/intent/post';

/**
 * Cache duration for API actions in seconds.
 * `1 minute`.
 */
export const ACTION_CACHE: Seconds = 60;

/**
 * Cache duration for API actions in seconds.
 * `10 minutes`.
 */
export const ACTION_CACHE_LONG: Seconds = 60 * 10;
